import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Divider } from '@sbt-web/ui';
import type { ItemMainFeature } from '@sbt-web/utils';
import type { SectionProps } from './section';
import ownClasses from './style/main-data.module.scss';
interface Props {
  features: ItemMainFeature[];
}
const MainData = t0 => {
  const $ = _c(4);
  const {
    features
  } = t0;
  let t1;
  if ($[0] !== features) {
    t1 = features.map(_temp);
    $[0] = features;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const featureList = t1;
  let t2;
  if ($[2] !== featureList) {
    t2 = <div className={ownClasses["main-features-container"]}>{featureList}</div>;
    $[2] = featureList;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
const MainDataSection = t0 => {
  const $ = _c(11);
  const {
    features,
    classes: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classes = t2;
  let t3;
  if ($[2] !== classes) {
    t3 = classNames(...classes);
    $[2] = classes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h6 className={classNames("headline-6", ownClasses.title)}>Dati principali</h6>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== features) {
    t5 = <MainData features={features} />;
    $[5] = features;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Divider spacing="null" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t5) {
    t7 = <section className={t3}>{t4}{t5}{t6}</section>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default MainDataSection;
function _temp(t0) {
  const {
    label: t1,
    placeholder: t2,
    iconURL
  } = t0;
  const label = t1 === undefined ? "" : t1;
  const placeholder = t2 === undefined ? null : t2;
  const hasLabel = label !== "";
  const hasPlaceholder = placeholder !== null;
  if (!hasLabel && !hasPlaceholder) {
    return null;
  }
  const displayLabel = hasLabel ? label : `- (${placeholder})`;
  return <div className={ownClasses["main-feature"]} key={iconURL}><img src={iconURL} alt="" width="16" height="16" loading="lazy" decoding="async" /><p className={classNames("caption", {
      [ownClasses.label]: hasLabel,
      [ownClasses.placeholder]: !hasLabel && hasPlaceholder
    })}>{displayLabel}</p></div>;
}